import classNames from '@ui-components-3/ui/lib/utils/classNames'

type NotificationBubbleProps = {
  amount: number
  isMobile?: boolean
  className?: string
}

const NotificationBubble = ({ amount, isMobile, className }: NotificationBubbleProps) => {
  return (
    <div
      className={classNames(
        'bg-fuchsia-800 rounded-full inline-flex items-center justify-center',
        isMobile ? 'px-1.5 absolute -top-1.5 -right-2.5 border border-white' : 'px-2 h-6 min-w-[24px]',
        className,
      )}
    >
      <p
        className={classNames(
          'font-medium text-white text-center -tracking-tight',
          isMobile ? 'typography-small' : 'typography-body',
        )}
      >
        {amount}
      </p>
    </div>
  )
}

export default NotificationBubble
